import styled from 'styled-components'

import { toRem } from 'styles'

type Props = {
	hasError: boolean
	isVisible: boolean
}

export const IconWrapper = styled.div<Props>`
	display: block;
	position: absolute;
	pointer-events: none;
	font-weight: normal;
	inset: calc(8px + ${toRem(8)}) auto auto 16px;
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	transition: color 0.2s, opacity 0.2s;
	color: ${({ hasError, theme }) => {
		if (hasError) {
			return theme.color.danger
		}
		return theme.color.textMuted
	}};
`
